<template>
  <div id="app">
    <notifications group="alert" position="bottom right" :duration="1000"></notifications>
    <base-layout></base-layout>
  </div>
</template>

<script>
import BaseLayout from './layouts/BaseLayout'

export default {
  name: 'App',
  components: { BaseLayout }
}
</script>
<style lang="scss">
@import 'assets/css/custom.css';

.vue-notification {
  padding: 15px;
  margin: 0 5px 5px;

  font-size: 12px;

  color: #ffffff;
  background: #44A4FC;
  border-left: 5px solid #187FE7;

  .notification-title {
    font-size: 1rem;
    padding: 0px 0px 10px 0px;
  }

}
</style>
